module.exports = __webpack_public_path__ + "img/win_item1.a96782e8.png";